// extracted by mini-css-extract-plugin
export var fullWidthButton = "_sh-0";